import { render } from "./QuestionInfo.vue?vue&type=template&id=793f9864&scoped=true"
import script from "./QuestionInfo.vue?vue&type=script&lang=js"
export * from "./QuestionInfo.vue?vue&type=script&lang=js"

import "./QuestionInfo.vue?vue&type=style&index=0&id=793f9864&scoped=true&lang=css"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-793f9864"]])

export default __exports__